import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ManualTaxinvoiceEditPage } from './manual-taxinvoice-edit.page';

const routes: Routes = [
  {
    path: '',
    component: ManualTaxinvoiceEditPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManualTaxinvoiceEditPageRoutingModule {}
